<template>
    <v-row>
        <v-col col="12" sm="6" md="4" style="border-right:1px solid #dbdbdb">
            <div class="text-center mt-6 font-weight-medium black--text" style="font-size:11px">MY PERFORMANCE</div>
        </v-col>
        <v-col col="12" sm="6" md="8" class="pl-0 pr-3">
            <!-- <div class="pt-3 pb-2 px-6">
                <div>
                    {{metrics.calif}}
                    <v-btn text class="accent--text" @click="detail=!detail">
                        <span v-if="detail==false">See detail</span>
                        <span v-if="detail==true">Close detail</span>
                    </v-btn>
                </div>
            </div> -->

            <div class="pt-3 pb-2 px-6">
                <div class="d-flex align-center">
                    <v-progress-circular :value="metrics.calif" color="red" size="60" width="6"></v-progress-circular>
                    <div class="font-weight-medium ml-4 grey--text text--darken-2">MY ENTIRE PROFILE</div>
                </div>
            </div>

            <v-divider></v-divider>
            
            <div class="pt-3 pb-2 pl-9">
                <div class="d-flex align-center">
                    <v-progress-circular :value="metrics.map.molecule.total*100/20" color="bMolecule" size="40" width="5"></v-progress-circular>
                    <div class="font-weight-medium ml-6 body-2 grey--text text--darken-1">MOLECULE</div>
                </div>

                <div class="d-flex align-center mt-4">
                    <v-progress-circular :value="metrics.map.mapOfLife.total*100/20" color="bMapCareer" size="40" width="5"></v-progress-circular>
                    <div class="font-weight-medium ml-6 body-2 grey--text text--darken-1">MAP OF LIFE</div>
                </div>

                <div class="d-flex align-center mt-4">
                    <v-progress-circular :value="metrics.map.top3.total*100/20" color="bTop" size="40" width="5"></v-progress-circular>
                    <div class="font-weight-medium ml-6 body-2 grey--text text--darken-1">TOP 3</div>
                </div>

                <div class="d-flex align-center mt-4">
                    <v-progress-circular :value="metrics.map.reputationPlanner.total*100/20" color="bPlanner" size="40" width="5"></v-progress-circular>
                    <div class="font-weight-medium ml-6 body-2 grey--text text--darken-1">REPUTATION PLANNER</div>
                </div>
            </div>

            <div v-if="detail">
                <v-divider></v-divider>
                <div class="caption grey--text text--darken-2 px-4 pt-4 pb-3">
                    <div class="font-weight-medium">
                        PHOTO: <span class="font-weight-medium primary--text">{{metrics.map.photo}}/5</span>
                    </div>
                    <div class="font-weight-medium">
                        PERSONAL SLOGAN: <span class="font-weight-medium primary--text">{{metrics.map.personalSlogan}}/5</span>
                    </div>
                    <div class="font-weight-medium">
                        PDA: <span class="font-weight-medium primary--text">{{metrics.map.pda}}/10</span>
                    </div>

                    <!-- MOLECULE -->
                    <div class="mt-4">
                        <div class="font-weight-medium">
                            MOLECULE: <span class="font-weight-medium primary--text">{{metrics.map.molecule.total}}/20</span>
                        </div>
                        <div class="pl-6">
                            Attributes: <span class="font-weight-medium primary--text">{{metrics.map.molecule.attributes}}/5</span>
                        </div>
                        <div class="pl-6">
                            Feelings: <span class="font-weight-medium primary--text">{{metrics.map.molecule.feelings}}/5</span>
                        </div>
                        <div class="pl-6">
                            Interests: <span class="font-weight-medium primary--text">{{metrics.map.molecule.interests}}/5</span>
                        </div>
                        <div class="pl-6">
                            GoodAt: <span class="font-weight-medium primary--text">{{metrics.map.molecule.goodAt}}/5</span>
                        </div>
                    </div>

                    <!-- MAP OF LIFE -->
                    <div class="mt-4">
                        <div class="font-weight-medium">
                            MAP OF LIFE: <span class="font-weight-medium primary--text">{{metrics.map.mapOfLife.total}}/20</span>
                        </div>
                        <div class="pl-6">
                            <div>In 15 Years:</div>
                            <div class="pl-10">
                                Vision: <span class="font-weight-medium primary--text">{{metrics.map.mapOfLife.a15.vision}}/3</span>
                            </div>
                            <div class="pl-10">
                                Objectives: <span class="font-weight-medium primary--text">{{metrics.map.mapOfLife.a15.obj1+metrics.map.mapOfLife.a15.obj2+metrics.map.mapOfLife.a15.obj3+metrics.map.mapOfLife.a15.obj3}}/2</span>
                            </div>
                        </div>
                        <div class="pl-6">
                            <div>In 10 Years:</div>
                            <div class="pl-10">
                                Vision: <span class="font-weight-medium primary--text">{{metrics.map.mapOfLife.a10.vision}}/3</span>
                            </div>
                            <div class="pl-10">
                                Objectives: <span class="font-weight-medium primary--text">{{metrics.map.mapOfLife.a10.obj1+metrics.map.mapOfLife.a10.obj2+metrics.map.mapOfLife.a10.obj3+metrics.map.mapOfLife.a10.obj3}}/2</span>
                            </div>
                        </div>
                        <div class="pl-6">
                            <div>In 5 Years:</div>
                            <div class="pl-10">
                                Vision: <span class="font-weight-medium primary--text">{{metrics.map.mapOfLife.a5.vision}}/3</span>
                            </div>
                            <div class="pl-10">
                                Objectives: <span class="font-weight-medium primary--text">{{metrics.map.mapOfLife.a5.obj1+metrics.map.mapOfLife.a5.obj2+metrics.map.mapOfLife.a5.obj3+metrics.map.mapOfLife.a5.obj3}}/2</span>
                            </div>
                        </div>
                        <div class="pl-6">
                            <div>In 1 Year:</div>
                            <div class="pl-10">
                                Vision: <span class="font-weight-medium primary--text">{{metrics.map.mapOfLife.a1.vision}}/3</span>
                            </div>
                            <div class="pl-10">
                                Objectives: <span class="font-weight-medium primary--text">{{metrics.map.mapOfLife.a1.obj1+metrics.map.mapOfLife.a1.obj2+metrics.map.mapOfLife.a1.obj3+metrics.map.mapOfLife.a1.obj3}}/2</span>
                            </div>
                        </div>
                    </div>

                    <!-- TOP3 -->
                    <div class="mt-4">
                        <div class="font-weight-medium">
                            TOP 3: <span class="font-weight-medium primary--text">{{metrics.map.top3.total}}/20</span>
                        </div>
                        <div class="pl-6">
                            Professions: <span class="font-weight-medium primary--text">{{metrics.map.top3.professions}}/5</span>
                        </div>
                        <div class="pl-6">
                            Majors: <span class="font-weight-medium primary--text">{{metrics.map.top3.majors}}/5</span>
                        </div>
                        <div class="pl-6">
                            Universities: <span class="font-weight-medium primary--text">{{metrics.map.top3.univs}}/5</span>
                        </div>
                        <div class="pl-6">
                            Companies: <span class="font-weight-medium primary--text">{{metrics.map.top3.companies}}/5</span>
                        </div>
                    </div>

                    <!-- REPUTATION PLANNER -->
                    <div class="mt-4">
                        <div class="font-weight-medium">
                            REPUTATION PLANNER: <span class="font-weight-medium primary--text">{{metrics.map.reputationPlanner.total}}/20</span>
                        </div>
                        <div class="pl-6">
                            Headline: <span class="font-weight-medium primary--text">{{metrics.map.reputationPlanner.headline}}/1</span>
                        </div>
                        <div class="pl-6">
                            Slogan: <span class="font-weight-medium primary--text">{{metrics.map.reputationPlanner.slogan}}/1</span>
                        </div>
                        <div class="pl-6">
                            Services: <span class="font-weight-medium primary--text">{{metrics.map.reputationPlanner.services}}/1</span>
                        </div>
                        <div class="pl-6">
                            ContactInfo: <span class="font-weight-medium primary--text">{{metrics.map.reputationPlanner.contactInfo}}/1</span>
                        </div>
                        <div class="pl-6">
                            About: <span class="font-weight-medium primary--text">{{metrics.map.reputationPlanner.about}}/1</span>
                        </div>
                        <div class="pl-6">
                            Skills: <span class="font-weight-medium primary--text">{{metrics.map.reputationPlanner.skills}}/1</span>
                        </div>
                        <div class="pl-6">
                            Interests: <span class="font-weight-medium primary--text">{{metrics.map.reputationPlanner.interests}}/1</span>
                        </div>
                        <div class="pl-6">
                            Languages: <span class="font-weight-medium primary--text">{{metrics.map.reputationPlanner.languages}}/1</span>
                        </div>
                        <div class="pl-6">
                            Experience: <span class="font-weight-medium primary--text">{{metrics.map.reputationPlanner.experience}}/1</span>
                        </div>
                        <div class="pl-6">
                            Volunteer: <span class="font-weight-medium primary--text">{{metrics.map.reputationPlanner.volunteer}}/1</span>
                        </div>
                        <div class="pl-6">
                            Education: <span class="font-weight-medium primary--text">{{metrics.map.reputationPlanner.education}}/1</span>
                        </div>
                        <div class="pl-6">
                            Organizations: <span class="font-weight-medium primary--text">{{metrics.map.reputationPlanner.organizations}}/1</span>
                        </div>
                        <div class="pl-6">
                            Courses: <span class="font-weight-medium primary--text">{{metrics.map.reputationPlanner.courses}}/1</span>
                        </div>
                        <div class="pl-6">
                            Projects: <span class="font-weight-medium primary--text">{{metrics.map.reputationPlanner.projects}}/2</span>
                        </div>
                        <div class="pl-6">
                            Honors: <span class="font-weight-medium primary--text">{{metrics.map.reputationPlanner.honors}}/1</span>
                        </div>
                        <div class="pl-6">
                            Contacts Professions: <span class="font-weight-medium primary--text">{{metrics.map.reputationPlanner.contacts_professions}}/1</span>
                        </div>
                        <div class="pl-6">
                            Contacts Majors: <span class="font-weight-medium primary--text">{{metrics.map.reputationPlanner.contacts_majors}}/1</span>
                        </div>
                        <div class="pl-6">
                            Contacts Universities: <span class="font-weight-medium primary--text">{{metrics.map.reputationPlanner.contacts_univs}}/1</span>
                        </div>
                        <div class="pl-6">
                            Contacts Companies: <span class="font-weight-medium primary--text">{{metrics.map.reputationPlanner.contacts_companies}}/1</span>
                        </div>
                    </div>
                </div>
            </div>
        </v-col>
    </v-row>
</template>

<script>
export default {
    data: () => ({
        detail: false
    }),
    props: ['metrics', 'color']
}
</script>